module.exports = __webpack_public_path__ + "static/img/index-channel.5eaaf9e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/index-channel.png
// module id = uhW3
// module chunks = 1